export default __webpack_public_path__ + "static/media/card.9aad4801.svg";